/**
 * Caminhos do sistema antigo (spec 009, secao 4.5 e T12). O endereco da area continua o mesmo depois da virada, entao
 * link velho de e-mail, de favorito e de mensagem vai continuar chegando aqui por muito tempo. Nada disto e regra de
 * marca: e uma lista de/para, e um link de senha antigo nunca vale como senha nova.
 */
import { Botao, BotaoLink, Pilha, TelaDeAcesso } from "@mtc/ui";
import { Navigate, Route, useNavigate } from "react-router";
import { marca } from "../config";

/** De/para dos caminhos antigos. A ordem importa: o mais especifico vem antes. */
export const CAMINHOS_ANTIGOS: [de: string, para: string][] = [
  ["/login", "/entrar"],
  ["/signup", "/entrar"],
  ["/onboarding", "/"],
  ["/sem-plano", "/"],
  ["/dashboard", "/"],
  ["/dashboard/planos", "/planos"],
  // O e-mail de compra do sistema antigo mandava agendar por aqui.
  ["/api/start-plan/:id", "/planos"],
  ["/dashboard/solicitacoes", "/solicitacoes"],
  ["/dashboard/financeiro", "/mensalidades"],
  ["/dashboard/financeiro/mensalidades", "/mensalidades"],
  ["/dashboard/financeiro/historico", "/mensalidades"],
  ["/dashboard/cobrancas", "/mensalidades"],
  ["/dashboard/termos", "/regulamento"],
  ["/dashboard/perfil", "/perfil"],
  ["/dashboard/certificados", "/certificados"],
  ["/dashboard/academy", "/academy"],
  ["/dashboard/academy/*", "/academy"],
  ["/dashboard/videos", "/academy"],
  ["/dashboard/videos/*", "/academy"],
  // Sem tela equivalente ainda: a pessoa cai no inicio em vez de num 404.
  ["/dashboard/gamification", "/"],
  ["/dashboard/ofertas-profit-pro", "/"],
  ["/dashboard/ai", "/"],
];

/** Links de senha e de convite do sistema antigo: o token de la nao vale aqui, entao a pessoa pede um novo. */
export const LINKS_DE_SENHA_ANTIGOS = ["/set-password", "/reset-password", "/auth/confirm", "/auth/callback"];

export function PaginaLinkAntigo() {
  const ir = useNavigate();
  return (
    <TelaDeAcesso marca={marca()} rotulo="Link do sistema antigo" frase="A área mudou. O endereço continua o mesmo, mas o link que você abriu é do sistema anterior.">
      <Pilha espaco={4}>
        <div style={{ display: "grid", gap: "var(--e-2)" }}>
          <h1 className="mtc-titulo">Este link é do sistema antigo</h1>
          <p className="mtc-texto-2" style={{ margin: 0 }}>
            Links de senha e de convite enviados antes da mudança não funcionam mais. Peça um link novo agora: leva menos de um minuto e chega no seu e-mail.
          </p>
        </div>
        <Botao onClick={() => ir("/suporte/senha")}>Criar minha senha agora</Botao>
        <BotaoLink href="/entrar" variante="secundario">Já tenho senha: entrar</BotaoLink>
        <p className="mtc-texto-2" style={{ margin: 0, fontSize: "var(--t-sm)" }}>
          Se o e-mail que você usava não é mais seu, use "Meu e-mail mudou" na tela de entrada. A gente confirma pelo CPF.
        </p>
      </Pilha>
    </TelaDeAcesso>
  );
}

/** As rotas de/para, pra entrar no roteador antes das telas normais. */
export function rotasDosCaminhosAntigos() {
  return [
    ...LINKS_DE_SENHA_ANTIGOS.map((de) => <Route key={de} path={de} element={<PaginaLinkAntigo />} />),
    ...CAMINHOS_ANTIGOS.map(([de, para]) => <Route key={de} path={de} element={<Navigate to={para} replace />} />),
  ];
}
